import Alert from "./Alert.ts"
import $ from 'jquery';


class API {
  static idToken = undefined;

  static callAPI(method, data, callbackSuccess, callbackError){
    if (method === undefined){
      throw new Error("aaaaaaaa");
    }
    if (data === undefined){
      data = {};
    }
    //var alertID = Alert.showAlert('hourglass', 'Várjon!');
    data.idToken = API.idToken;

    var jsonstring = JSON.stringify({
        method:method,
        data:data
    });

    $.ajax({
      url: "http://radius.kig.hu/api/api.php",
      headers: {
        "Access-Control-Allow-Origin" : "*",
        "Access-Control-Allow-Methods" : "GET,POST,PUT,DELETE,OPTIONS",
        "Access-Control-Allow-Headers": "content-type, Content-Type, access-control-allow-origin, Access-Control-Allow-Headers, Authorization, X-Requested-With"
      },
      async: true,
      crossDomain: true,
      type: 'POST',
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      data: jsonstring,
      success:function(response) {
        //if (ZSK != null){
          if (response.status !== 'danger'){
            /*
            NEM DANGER
            */
            if ((response.userMsg !== undefined) && (response.userMsg !== '')){
              Alert.showAlert(response.status, response.userMsg);
            }
            callbackSuccess(response);
          } else{
            /*
            DANGER
            */
            console.log("Response: " + response.status + " - " + response.techMsg);
            Alert.showAlert(response.status, response.userMsg);
            if (callbackError !== undefined){
              callbackError(response);
            }
          }
        //}
      },
      error: function(e) {
        //if (ZSK != null){
          console.log("api err: " + e.responseText);
          Alert.showAlert('danger', e.responseText);
        //}else{
          //alert("API Error: " + e.responseText);
          //$('#errorPanel').html(e.responseText);
          //$('#errorPanel').show();
        //}
      }
    });
  }

  static getAPIURL(){
    // return "http://" + document.domain + "/metronom/build/api.php";
    //alert(window.location.href);
    //return window.location.protocol + "//" + window.location.hostname + "/" + window.location.pathname +  "/api.php";
    return window.location.protocol + "//" + window.location.hostname + "/api.php";
    //return "http://" + document.domain + "/api.php";
  }
}

export default API